import React from 'react'
import naturalStoneMainBgImg from '../../../assets/img/banner-natural-stone/natural-stone-base-background.jpg'
import LocalizedLink from '../../global/LocalizedLink'
import Translation from '../../global/Translation'
import { getLanguageDir } from '../../../store/ui/reducers'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

const BannerHomeCatalogNaturalStone = ({languageDir}) => {
    return (
        <div
            className="banner-home-catalog-natural-stone"
            style={{
                backgroundImage: `url(${naturalStoneMainBgImg})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                height: '100%',
                width: '100%'
            }}
        >
            <div className="banner-overlay"></div>
            <div className="banner-content">
                <div className="main-title">
                    <h2>
                        <Translation id="new_natural_stone_section" defaultMessage="New Natural Stone section" />
                    </h2>
                </div>
                <div className="text-content">
                    <p>
                        <Translation id="discover_our_section_of_granite_marble" defaultMessage="Discover our selection of granite, marble, and quartzite. Access the latest products and discover the outlet at the best price." />
                    </p>
                </div>
                <div className="cta-button">
                    <LocalizedLink routeId="ROUTE_NATURAL_STONE" queryString="">
                        <button gtm-label="ec_home_banner_mosaico">
                            <Translation id="access" defaultMessage="Access" />
                            <i class={languageDir === 'rtl' ? "fa fa-long-arrow-left" : "fa fa-long-arrow-right"} aria-hidden="true" />
                        </button>
                    </LocalizedLink>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        languageDir: getLanguageDir(state)
    }
}

export default injectIntl(connect(mapStateToProps, null)(BannerHomeCatalogNaturalStone));
